module.exports = __webpack_public_path__ + "static/whitedressing-e76ab8a242e862293c0050bba7401442.png";